'use strict'

const identity_ = require('lodash/identity')
const result = require('folktale/result')

const configureRaven = require('dbsm-common/src/raven/configureForWorker')

const getSantaVersionFromWorkerUrl = workerUrl => {
  const santaVersionMatch = workerUrl.match(/santa\/([^/]*)/)
  return santaVersionMatch ? santaVersionMatch[1] : 'unknown'
}

const tryOrGetUnknown = callback => result.try(callback).getOrElse('unknown')
const tryOrGetError = callback =>
  result.try(callback).matchWith({
    Ok: ({ value }) => value,
    Error: ({ value: error }) => error.message
  })

const getExtraDebugData = globalScope => ({
  referrer: tryOrGetError(() => globalScope['wix-window'].referrer),
  workerUrl: tryOrGetError(() => globalScope.location.href)
})

const getTags = globalScope => ({
  viewMode: tryOrGetUnknown(() => globalScope['wix-window'].viewMode),
  santaVersion: tryOrGetUnknown(() =>
    getSantaVersionFromWorkerUrl(globalScope.location.href)
  )
})

module.exports = (Raven, globalScope, dsn, params = {}, appName) => {
  configureRaven({
    appName,
    urlGetter: () => tryOrGetUnknown(() => globalScope['wix-location'].url),
    Raven,
    dsn,
    params
  })

  Raven.setDataCallback((data, originalCallback = identity_) => {
    data.extra = Object.assign(data.extra || {}, getExtraDebugData(globalScope))
    data.tags = Object.assign(data.tags || {}, getTags(globalScope))

    return originalCallback(data)
  })
}



// WEBPACK FOOTER //
// ./raven/setupRaven.js